import React from 'react';
import PropTypes from 'prop-types';

import Description from './Description';
import Title from './Title';
import { SIZES } from '../constants';
import { SIZES as TEXT_SIZES } from '../../Text';
import { classes } from '../MarketingLayout.st.css';

const descriptionSizeBySize = {
  [SIZES.tiny]: TEXT_SIZES.small,
  [SIZES.small]: TEXT_SIZES.small,
  [SIZES.medium]: TEXT_SIZES.medium,
  [SIZES.large]: TEXT_SIZES.medium,
};

const Content = ({ size, actions, title, description }) => (
  <div className={classes.contentContainer}>
    <div>
      <Title size={size}>{title}</Title>
      <Description size={descriptionSizeBySize[size]}>
        {description}
      </Description>
    </div>
    {actions}
  </div>
);

Content.propTypes = {
  size: PropTypes.string,
  actions: PropTypes.node,
  title: PropTypes.node,
  description: PropTypes.node,
};

export default Content;
